var path = 'public/app/features/org/partials/orgDetails.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <h3 class=page-sub-heading>Organization profile</h3>\n\n  <form name=orgForm class=gf-form-group>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-28\">\n        <span class=gf-form-label>Organization name</span>\n        <input class=gf-form-input type=text required ng-model=org.name>\n      </div>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button type=submit class=\"btn btn-success\" ng-click=update()>Save</button>\n    </div>\n  </form>\n  <prefs-control mode=org></prefs-control>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/org/partials/orgDetails.html
// module id = 1072
// module chunks = 3